import { useFirestoreCollection } from "./useFirestoreCollection";

export const useUsers = () => {
  const [users, isLoading] = useFirestoreCollection("users");

  return [users, isLoading] as const;
};
